import { render, staticRenderFns } from "./FareRules.vue?vue&type=template&id=74aa7be3&scoped=true&"
import script from "./FareRules.vue?vue&type=script&lang=js&"
export * from "./FareRules.vue?vue&type=script&lang=js&"
import style0 from "./FareRules.vue?vue&type=style&index=0&id=74aa7be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa7be3",
  null
  
)

export default component.exports